// import isProdEnv from 'envProd'; // provided by rollup-plugin-virtual
import {Loader, Logger, PubSub, TCFHandler} from '@mamdev/cad.static-next-lib';
import {Accessibility} from '../services/accessibility';
import ASLoader from '../services/asloader';
import {Taboola} from '../services/taboola';
import Tracking from '../services/tracking';
import {UrlPath} from '../services/url-path';
import Viewport from '../services/viewport';
import WebVitals from '../services/webvitals';
import PromoCookieHandler from '../services/promocookiehandler';

export const App = {
  instance_: null,

  get instance() {
    if (!this.instance_) {
      this.instance_ = {
        loader_: Loader,
        logger_: Logger,
        pubsub_: PubSub,
        perf_: window.performance || {mark: () => {}},
        primisScriptPart: 'https://live.primis.tech/live/liveView.php?s=',
        primisScriptIds: {
          'mailcom': {
            'small': '109485',
            'large': '109383'
          },
          'gmxcom': {
            'small': '122919',
            'large': '123091'
          },
          'gmxcouk': {
            'small': '122919',
            'large': '123091'
          },
          'gmxes': {
            'small': '122917',
            'large': '123090'
          },
          'gmxfr': {
            'small': '122918',
            'large': '123092'
          }
        },

        start(initializer, assetPath = {css: '', js: ''}) {
          try {
            if (typeof initializer !== 'function') {
              console.warn('No auto-initializer set!');
              return;
            }

            // if (isProdEnv) {
            //  this.logger_.mute();
            // }

            // set paths
            UrlPath.paths = {
              css: assetPath.css,
              js: assetPath.js,
              assets: `${assetPath.js}/../module_assets`
            };

            // mock User Timing API, necessary for Safari and PhantomJS
            window.performance = window.performance || {};
            // somehow when running Karma tests, window.performance is defined
            // but the mark method is not (?)
            window.performance.mark = window.performance.mark || function() {};

            this.pubsub_.subscribe('mod:init', e => {
              this.logger_.log('app', `Module "${e.moduleName}" initialized.`);
            });

            this.pubsub_.subscribe('mod:dynInit', modRoot => {
              initializer(modRoot, undefined, this.loader_, assetPath);
            });

            // listen to visibilitystate change, i.e. browser tab becomes active/inactive
            document.addEventListener('visibilitychange', e => {
              this.pubsub_.publish('visibilityStateChanged', e);
              // this.logger_.log('app', 'visibilityState changed to: ' + e.target.hidden);
            });

            // global function to receive events from static current
            window.publishToStaticNext = (topic, data) => {
              this.pubsub_.publish(topic, data);
            };
            // global function to receive events from new to current static
            window.publishToStaticCurrent = (topic, data) => {
              potec.sendMessage(topic, data);
            };

            TCFHandler.init();
            Accessibility.init();
            WebVitals.run();
            Tracking.initialize();
            Taboola.run();
            PromoCookieHandler.init();

            if (typeof window.ui.jsCountUrl !== 'undefined') {
              this.pubsub_.publish('mcomSitestat', window.ui.jsCountUrl);
            }

            this.perf_.mark('adservice-init-start');
            this.loadAdService();
            this.perf_.mark('adservice-init-end');

            // Auto initialize modules on page
            initializer(undefined, undefined, this.loader_, assetPath);

            /**
             * Works as throttle function in lodash or underscore. Scroll event is wrapped in a timeout as to avoid
             * making it trigger hundreds of times in a second.
             *
             * @param {number} timeout
             */
            function throttleWindowScroll(timeout) {
              let scrollTimer;

              window.addEventListener('scroll', () => {
                if (scrollTimer) {
                  window.clearTimeout(scrollTimer);
                }
                scrollTimer = setTimeout(function() {
                  PubSub.publish('windowScrolling');
                }, timeout);
              });
            }

            throttleWindowScroll(50);

            // Load Primis videos
            {
              const primisContainer = document.getElementsByClassName('primis')[0];

              if (primisContainer) {
                const script = document.createElement('script');
                script.defer = true;

                let scriptSrc;

                if (Viewport.isMobile() || window.innerWidth >= 1420) {
                  scriptSrc = `${this.primisScriptPart}${this.primisScriptIds[ui.tenant]['large']}`;
                  script.classList.add('large');
                } else {
                  scriptSrc = `${this.primisScriptPart}${this.primisScriptIds[ui.tenant]['small']}`;
                  script.classList.add('small');
                }

                script.src = scriptSrc;
                primisContainer.appendChild(script);
              }
            }
          } catch (e) {
            this.logger_.log('app', 'error: ' + e);
          }
        },

        /**
         * Loads ad components and starts the ad service
         */
        loadAdService() {
          try {
            const biddingConfigUrls = window.ui.AdServiceConfig.biddingConfigUrls;
            const layoutClass = Viewport.getLayoutClass();

            ASLoader.baseUrl = UrlPath.paths.js + '/../';
            ASLoader.configFileUrl = biddingConfigUrls[layoutClass];
            ASLoader.run();
          } catch (e) {
            this.logger_.log('app', 'error: ' + e);
          }
        }
      };
    }
    return this.instance_;
  }
};
